/**
 * Handles touch/tap activation for group blocks on mobile devices.
 * Toggles a 'group-block--touched' class when the group is tapped,
 * and removes it when tapping elsewhere.
 */

const initGroupTouchActivate = () => {
  // Prevent multiple initializations
  if (window.groupTouchActivateInitialized) return;
  window.groupTouchActivateInitialized = true;

  const TOUCHED_CLASS = 'group-block--touched';
  const TOUCH_ACTIVATE_CLASS = 'group-block--touch-activate';

  // Use event delegation on document - works for dynamically added content
  document.addEventListener('click', (event) => {
    const group = event.target.closest(`.${TOUCH_ACTIVATE_CLASS}`);

    if (group) {
      // Toggle the touched state on clicked group
      if (group.classList.contains(TOUCHED_CLASS)) {
        group.classList.remove(TOUCHED_CLASS);
      } else {
        // Remove touched state from all other groups first
        const allTouchedGroups = document.querySelectorAll(`.${TOUCHED_CLASS}`);
        for (const touchedGroup of allTouchedGroups) {
          touchedGroup.classList.remove(TOUCHED_CLASS);
        }
        group.classList.add(TOUCHED_CLASS);
      }
    } else {
      // Clicked outside any touch-activate group - remove all touched states
      const allTouchedGroups = document.querySelectorAll(`.${TOUCHED_CLASS}`);
      for (const touchedGroup of allTouchedGroups) {
        touchedGroup.classList.remove(TOUCHED_CLASS);
      }
    }
  });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGroupTouchActivate);
} else {
  initGroupTouchActivate();
}
